module.exports = __webpack_public_path__ + "mm-icons.ttf";